//axios 配置
import Vue from 'vue'
import router from '../router'
import axios from 'axios'
import store from '../vuex/store'
import {Message, MessageBox} from 'element-ui'
import methods from '../methods/index'

axios.defaults.baseURL = '/api'; // 开发环境用(此配置仅供本地跨域调试，线上跨域需要后台开启相应权限)
// axios.defaults.baseURL = ''; // 生产环境
axios.defaults.timeout = 30000;

//Axios请求拦截器
axios.interceptors.request.use(config => {
  // let token = window.sessionStorage.getItem('token'); //获取loginToken
  let token = store.state.token; //获取loginToken
  if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers['Authorization'] = token;
    config.headers['Pragma'] = 'no-cache';
    config.headers['Cache-Control'] = 'no-cache';
  }
  return config
}, error => {
  return Promise.reject(error);
});

// 状态响应
axios.interceptors.response.use((res) => {
  
  // 接口提示
  if (!methods.isInvalid(res.data.code)) {
    
    // 错误状态提示
    if (res.data.code !== 0 && res.data.code !== 10007 && store.state.isPublicAlarm) {
      Message({
        type: 'warning',
        message: res.data.msg
      });
    }
    
    // 登录超时提示
    else if (res.data.code === 10007 && store.state.loginTimeout.isAlert === false) {
      store.commit('setLoginTimeOutCount', true);
      
      MessageBox.confirm('登录已超时，是否重新登录', '系统消息', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        store.commit('syncToken', ''); // 更新token信息
        window.localStorage.removeItem('token');
        
        Message({
          type: 'warning',
          message: '即将跳转至登录页'
        });
        
        setTimeout(() => {
          window.location = '/'; // 跳转至登录页
        }, 500);
        
      }).catch(() => {
        store.commit('setLoginTimeOutCount', false);
        Message({
          type: 'info',
          message: '不登录'
        });
      });
    }
  }
  
  return res;
}, (error) => {
  Message({
    type: 'error',
    message: '系统服务维护中或网络异常，请稍后重试'
  });
  
  return error
});

//(发送delete请求) // url = /admin/user/{id}?loginToken={loginToken}
export function del(url, params, timeout) {
  return axios({
    url: url,
    params: params,
    method: 'delete',
    timeout: timeout
  })
}

//(发送put请求)
export function put(url, params, timeout) {
  return axios({
    url: url,
    params: params,
    method: 'put',
    timeout: timeout
  })
}

// get方式下载文件
export function getDownload(url, params, timeout) {
  
  return axios({
    url: url,
    params: params,
    method: 'get',
    timeout: timeout,
    responseType: 'blob'
  })
}

//(发送get请求)
export function get(url, params, timeout) {
  return axios({
    url: url,
    params: params,
    method: 'get',
    timeout: timeout
  })
}

//(发送post请求)
export function post(url, data, timeout) {
  return axios({
    url: url,
    method: 'post',
    data: data,
    timeout: timeout
  })
}

//(发送post请求)
export function postForm(url, data, timeout) {
  return axios({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [
      function () {
         let ret = ''
         for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
         }
         ret = ret.substring(0, ret.lastIndexOf('&'));
         return ret
      }
    ],
    timeout: timeout
  })
}


// post方式下载文件
export function postDownload(url, data, timeout) {
  return axios({
    url: url,
    data: data,
    method: 'post',
    timeout: timeout,
    responseType: 'blob'
  })
}

//格式化get查询字符串
export function formatGetUrl(obj) {
  if (typeof(obj) === 'object') {
    let str = '';
    let getUrl = '';
    for (let i in obj) {
      if (obj[i] || obj[i] === 0 || obj[i] === '0') {
        str += i + '=' + encodeURIComponent(obj[i]) + '&'
      }
    }
    return str.replace(/&$/g, '');
  }
}

export default axios;
